export default __webpack_public_path__ + "static/media/bg.87f95b7b.mp4";